var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update-status-sheet",class:_vm.outlined && 'update-status-sheet--outlined',style:(`--color: ${_vm.color}; --text-color: ${_vm.textColor}`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }